export const openScheduleModal = () => ({
  type: "OPEN_SCHEDULE_MODAL",
});

export const closeScheduleModal = () => ({
  type: "CLOSE_SCHEDULE_MODAL",
});
